import type { OrderVm } from 'src/api/pidedirecto/types/OrderVm';
import { OrderTypes } from 'src/constants/OrderType';

export function orderIsInternalDeliveryOrder(order: OrderVm): boolean {
    return order.orderType === OrderTypes.DELIVERY_ORDER && !order.externalDelivery;
}
